export default "__VITE_ASSET__22fd12e5__"